import { render, staticRenderFns } from "./App.vue?vue&type=template&id=647d3f00"
var script = {}
import style1 from "./App.vue?vue&type=style&index=1&id=647d3f00&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports